/* ================================================================
   rq-video-fix.js

   Companion to snippets/rq-video-lazyplay.liquid. That snippet OWNS
   playback and loading. This file must never call load() or play() -
   an earlier version did, and because deferred scripts run before
   DOMContentLoaded while the lazy player's scan() waits for it, this
   file ran FIRST, called load() on videos that still had their markup
   preload="auto", and started every video downloading at once. That
   is precisely the stampede the lazy player exists to prevent, and
   this file was reintroducing it on every page load.

   So this file now only does what the lazy player does not:

   1. CORRECT A LYING MIME TYPE. Any <source> whose type attribute
      disagrees with its file extension is corrected, and MP4 sources
      are moved first. Safari trusts the type attribute and refuses a
      source it believes is the wrong format without ever reading the
      file; Chrome sniffs the bytes and plays it anyway. Because the
      correction happens before the lazy player ever loads anything,
      no load() call is needed here for it to take effect.

   2. RESCUE AN IMAGE IN A VIDEO TAG. One block points a <video> at a
      .webp still. Nothing can play that, so the <video> is swapped
      for an <img>.

   3. DIAGNOSTIC. Add ?rqvideocheck=1 to any URL, on the phone, for a
      panel listing every video with its source, declared type,
      readyState and real error code.
        readyState 0 = nothing loaded, 4 = fully buffered
        error 0 = none  1 = aborted  2 = network
              3 = decode (codec this device cannot handle)
              4 = src not supported (wrong type attribute or bad URL)
   ================================================================ */
(function () {
  'use strict';

  if (window.__rqVideoFix) return;
  window.__rqVideoFix = true;

  var RE_MP4 = /\.(mp4|m4v)(\?|#|$)/i;
  var RE_WEBM = /\.webm(\?|#|$)/i;
  var RE_IMG = /\.(webp|jpe?g|png|gif|avif)(\?|#|$)/i;

  function wantedType(url) {
    if (RE_MP4.test(url)) return 'video/mp4';
    if (RE_WEBM.test(url)) return 'video/webm';
    return '';
  }

  function fixTypes(v) {
    var srcs = v.querySelectorAll('source');

    for (var i = 0; i < srcs.length; i++) {
      var s = srcs[i];
      var url = s.getAttribute('src') || '';
      if (!url) continue;

      var want = wantedType(url);
      var have = s.getAttribute('type') || '';

      if (want && have !== want) s.setAttribute('type', want);
      else if (!want && have) s.removeAttribute('type');
    }

    /* MP4 first: browsers take the first source they believe they can
       play, and MP4 / H.264 is the only safe bet on iOS. */
    var list = Array.prototype.slice.call(v.querySelectorAll('source'));
    var first = null;
    for (var j = 0; j < list.length; j++) {
      if (RE_MP4.test(list[j].getAttribute('src') || '')) { first = list[j]; break; }
    }
    if (first && list[0] !== first) v.insertBefore(first, list[0]);
  }

  function rescueImage(v) {
    var srcs = v.querySelectorAll('source');
    var url = '';

    for (var i = 0; i < srcs.length; i++) {
      var u = srcs[i].getAttribute('src') || '';
      if (RE_IMG.test(u)) { url = u; break; }
    }
    if (!url) return false;

    var img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.loading = 'lazy';
    img.className = v.className;
    img.setAttribute('data-rq-rescued', '1');
    if (v.style && v.style.cssText) img.style.cssText = v.style.cssText;

    if (v.parentNode) v.parentNode.replaceChild(img, v);
    return true;
  }

  function inspect(v) {
    if (v.__rqInspected) return;
    v.__rqInspected = true;

    if (rescueImage(v)) return;

    fixTypes(v);

    v.addEventListener('error', function () {
      var s = v.querySelector('source');
      if (window.console && console.warn) {
        console.warn('[rq-video] failed. code=' + (v.error ? v.error.code : '?') +
          ' src=' + (s ? s.getAttribute('src') : '?'));
      }
    }, true);
  }

  function scan() {
    var vids = document.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) inspect(vids[i]);
  }

  var t = null;
  function scanSoon() {
    if (t) return;
    t = setTimeout(function () { t = null; scan(); }, 200);
  }

  function boot() {
    scan();
    new MutationObserver(scanSoon).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    if (location.search.indexOf('rqvideocheck=1') > -1) setTimeout(report, 4000);
  }

  function report() {
    var vids = document.querySelectorAll('video');
    var probe = document.createElement('video');
    var box = document.createElement('div');

    box.style.cssText =
      'position:fixed;left:0;right:0;bottom:0;max-height:70vh;overflow:auto;' +
      'z-index:2147483647;background:#fff;color:#111;font:12px/1.45 monospace;' +
      'padding:12px 12px 64px;border-top:3px solid #ffc107';

    var html = '<b>rq video check</b> &mdash; ' + vids.length + ' video element(s)<br>' +
      'this device can play mp4: <b>' + (probe.canPlayType('video/mp4') || 'no') + '</b><br>' +
      'webm: <b>' + (probe.canPlayType('video/webm') || 'no') + '</b><hr>';

    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      var s = v.querySelector('source');
      var url = s ? (s.getAttribute('src') || '') : '(no source)';
      var type = s ? (s.getAttribute('type') || '(none)') : '-';

      html += '<div style="margin-bottom:10px">#' + (i + 1) +
        ' ready=' + v.readyState +
        ' net=' + v.networkState +
        ' err=' + (v.error ? v.error.code : 0) +
        ' paused=' + v.paused +
        ' want=' + (v.dataset.rqWant || '-') +
        ' shown=' + (v.offsetParent !== null) +
        '<br>type=' + type +
        '<br>' + url.split('/').pop().split('?')[0] + '</div>';
    }

    html += '<button id="rqvcx" style="position:fixed;right:12px;bottom:12px;' +
      'padding:10px 16px;background:#111;color:#fff;border:0;border-radius:6px">close</button>';

    box.innerHTML = html;
    document.body.appendChild(box);

    var x = document.getElementById('rqvcx');
    if (x) x.addEventListener('click', function () { box.parentNode.removeChild(box); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
